import React from 'react';
import Icon from '../../../components/AppIcon';

const SocialProofSection = () => {
  const clientLogos = [
    { name: "Diotal", color: "text-blue-500" },
    { name: "Reeyo", color: "text-green-500" },
    { name: "STN Technologies", color: "text-orange-500" },
    { name: "TrustHaven", color: "text-yellow-500" },
    { name: "CodersHub", color: "text-purple-500" },
    { name: "Skilldera", color: "text-indigo-500" },
    { name: "IMAC Prepa", color: "text-red-500" },
    { name: "ADFX", color: "text-cyan-500" },
    { name: "OfferBid", color: "text-pink-500" }
  ];

  return (
    <section className="py-20 bg-muted/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center space-x-2 mb-4">
            <Icon name="Trophy" size={20} className="text-primary" />
            <span className="text-sm font-brand-medium text-primary tracking-wide uppercase">Social Proof</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-brand-headline text-foreground mb-6">
            Trusted by Companies &
            <span className="block text-primary text-gradient-gold">Building in the Open</span>
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto font-brand-body">
            The products and companies I've built and worked on.
          </p>
        </div>

        {/* Client Logos with Names */}
        <div className="text-center">
          <h3 className="text-xl font-brand-subheading text-foreground mb-8">
            Products & Companies
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-8 items-center">
            {clientLogos?.map((client, idx) => (
              <div
                key={idx}
                className="py-4 px-2 bg-card rounded-xl border border-border hover:border-primary/30 transition-all duration-300 brand-shadow hover:brand-shadow-lg"
              >
                <div className={`text-base sm:text-lg font-brand-medium text-center ${client.color}`}>
                  {client.name}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProofSection;
